const Promotions = {
    startTime: "1767589983000",
    endTime: "1785522599000",
    price: {
        elite: "499",
        intro: "399",
        upgrade: "600"
    },
    cashback: {
        elite: "5"
    }
}

export default Promotions;

